import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular4-notifications';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent implements OnInit {
	
	connectedUser: any;
	user: any;
	editProfile: boolean = false;
	formUser: FormGroup;
	id: number;
	enabled: boolean = true;
	password: string;
	username: string;
  roles: any;
  sex: boolean;
  firstname: string;
  name: string;
  birth_date: any;
  email: string;
  phone: string;
  street: string;
  post_code: string;
  city: string;
  avatar_url: string;
  avatar: any;
  country: string;
  showAll: boolean = false;
  autocompleteSettings: any = {
    inputPlaceholderText: 'Saisir une adresse',
    showSearchButton: false,
  };
  formErrors: string;

  apiEndPoint: string;
  isLoading: boolean = false;

  @ViewChild('fileInput') fileInput: ElementRef;


  constructor(
  	private http: HttpClient, 
  	private fb: FormBuilder,
    private notificationService: NotificationsService) { }

  ngOnInit() {
  	// Get connected user from local storage
  	this.connectedUser = JSON.parse(localStorage.getItem('currentUser'));

    if(this.connectedUser.roles.indexOf('ROLE_USER') > -1){
      this.apiEndPoint = environment.symfonyEndpointSecuredForUser;
    }else if(this.connectedUser.roles.indexOf('ROLE_COMPANY') > -1){
      this.apiEndPoint = environment.symfonyEndpointSecuredForCompany;
    }

  	this.loadUser(this.connectedUser.username);
  }


  loadUser(username:string){

  	return this.http.get(this.apiEndPoint + environment.apiGetUserByUsername + username).map((res: Response) => res).subscribe(user => {
      this.user = user;
      this.loadForm() })
  }

  loadForm(){
  	this.formUser = this.fb.group({
  		'id' : [this.user['id']],
  		'enabled' : [this.user['enabled']],
  		'password' : [this.user['password']],
      'roles' : [this.user['roles']],
      'country' : [this.user['country']],
      'username' : [this.user['username'], Validators.required],
      'sex' : [this.user['sex'], Validators.required],
      'firstname' : [this.user['firstname'], Validators.required],
      'name' : [this.user['name'], Validators.required],
      'birth_date' : [this.user['birth_date'], Validators.required],
      'email' : [this.user['email'], Validators.required],
      'phone' : [this.user['phone'], Validators.required],
      'street' : [this.user['street'], Validators.required],
      'post_code' : [this.user['post_code'], Validators.required],
      'city' : [this.user['city'], Validators.required],
      'avatar_url' : [this.user['avatar_url']],
      'avatar' : null
    });
  }

  toggleEditProfile(){
  	this.editProfile = this.editProfile === true ? false : true;
  }

  submitProfile(data){

  	if (this.formUser.valid) {
      this.isLoading = true;
	  	// Get all values from the form
	  	const formModel = this.formUser.value;
	  	// refresh user to show on edit mode
  		this.user = data;

	    const req = this.http.put(this.apiEndPoint + environment.apiEditUser, formModel)
	      .subscribe(
	        res => {
	        	// console.log(res);
	          this.notificationService.success('', 'Modifications sauvegardées');
            this.toggleEditProfile();
            this.showAll = false;
            this.formErrors = '';
          this.isLoading = false;
	        },
	        err => {
            this.isLoading = false;
            if(err.status === 400){
              this.formErrors = JSON.parse(err['error']).message;
            }else{
              this.notificationService.error('Oups', 'Une erreur est survenue.');
            }
	        }
	      );
	}else{
		this.showAll = true;
    this.isLoading = false;
	}

  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.formUser.get('avatar').setValue({
          filename: this.user.id + '-' + file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        });
        this.formUser.get('avatar_url').setValue(this.user.id + '-' + file.name);
      };
    }
  }

  autoCompleteAddress(selectedData:any) {
    for (var i in selectedData.data.address_components) {
      var component = selectedData.data.address_components[i];
      for (var j in component.types) {  // Some types are ["country", "political"]
        var type_element = component.types[j];
        switch (type_element) {
          case "street_number":
            this.formUser.get('street').setValue(component.long_name);
            break;
          case "route":
            this.formUser.get('street').setValue(this.formUser.get('street').value + ' ' + component.long_name);
            break;
          case "postal_code":
            this.formUser.get('post_code').setValue(component.long_name);
            break;
          case "locality":
            this.formUser.get('city').setValue(component.long_name);
            break;
          
          default:
            // code...
            break;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/users/user-profile/user-profile.component.ts